import React from 'react';
import { Link } from 'react-router-dom';
import { guides } from '../data/admissionData';
import { usePageMeta } from '../hooks/usePageMeta';
import '../styles/Guides.css';

const Guides = () => {
  usePageMeta({
    title: '가이드',
    description:
      'EJU·일반·국비·종합형·요강 읽는 법 등 일본 학부 입시 가이드. 참고용이며 원문이 우선입니다.',
    path: '/guides',
  });

  return (
    <div className="apple-page apple-guides">
      <header className="apple-page-hero">
        <p className="apple-eyebrow">Guides</p>
        <h1 className="apple-display">가이드</h1>
        <p className="apple-lede">
          일본 입시 루트를 이해하기 위한 해설입니다. 참고용이며, 최종 확인은 대학 모집요항 원문입니다.
        </p>
      </header>

      <ul className="apple-guide-list">
        {guides.map((guide) => (
          <li key={guide.id} id={guide.id}>
            <Link to={`/guides/${guide.id}`} className="apple-guide-card">
              <p className="apple-guide-meta">
                {guide.category} · {guide.readTime}
                {guide.updatedAt ? ` · ${guide.updatedAt}` : ''}
              </p>
              <h2>{guide.title}</h2>
              <p>{guide.summary}</p>
              <span className="apple-rail-more">읽기</span>
            </Link>
          </li>
        ))}
      </ul>

      <div className="apple-page-foot">
        <Link to="/checklist" className="apple-btn apple-btn-primary">
          요강 체크리스트
        </Link>
        <Link to="/compare" className="apple-link">
          대학 비교
        </Link>
        <Link to="/glossary" className="apple-link">
          용어집
        </Link>
        <Link to="/calendar" className="apple-link">
          시즌 일정
        </Link>
        <Link to="/finder" className="apple-link">
          루트 파인더
        </Link>
      </div>
    </div>
  );
};

export default Guides;
